import * as React from 'react';

function SvgComponent(props) {
    const size = props?.size || 32;
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect width={32} height={32} rx={16} fill="#2D8CFF" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.2 23.961L12 24h12l-.04-.798c-.108-1.316-1.04-2.277-2.36-2.362l-.8-.04h-7.199L23.2 11.2l-.039-.797c-.062-1.33-1.033-2.29-2.36-2.363l-.8-.036L8 8l.04.8c.104 1.303 1.05 2.285 2.358 2.36l.802.04h7.199L8.8 20.8l.039.8c.079 1.32 1.03 2.275 2.36 2.36z"
                fill="#fff"
            />
        </svg>
    );
}

export default SvgComponent;
